import { FC } from "react";

import { CampaignType } from "@vviinn/user-managment-client-ts";
import { LARGE_ICON_SIZE_STYLES } from "../../../ui/styles";
import { styledIcon } from "../../../ui/layout/general/styledIcon";

type CampaignTileIconProps = {
  type: CampaignType;
  isActive?: boolean;
};

const CAMPAIGN_TILE_ICON_STYLES = (isActive = true) =>
  `${LARGE_ICON_SIZE_STYLES} ${
    isActive ? "text-green-100" : "text-white dark:text-stone-400"
  } `;

export const CampaignTileIcon: FC<CampaignTileIconProps> = ({
  type,
  isActive,
}: CampaignTileIconProps) => {
  return styledIcon(type, CAMPAIGN_TILE_ICON_STYLES(isActive));
};
